<template>
  <div class="custom-table-wrapper">
    <div class="table-container-custom">
      <b-table
        ref="bTable"
        class="table-admin-custom w-full text-left"
        :current-page="currentPage"
        :per-page="perPage"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <!-- Forward all scoped slots dynamically to b-table -->
        <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="slotProps">
          <slot :name="slotName" v-bind="slotProps" />
        </template>
      </b-table>
    </div>

    <!-- Phân trang và Thống kê tổng số lượng (Sử dụng component Pagination tái sử dụng) -->
    <div v-if="showFooter" class="table-footer-bar">
      <div class="footer-stats-text">
        Hiển thị <span class="stats-highlight">{{ numberOfElement }}</span> trên tổng số <span
          class="stats-highlight">{{ totalRows }}</span> dòng dữ liệu
      </div>

      <div class="dataTables_paginate paging_simple_numbers">
        <Pagination
          :value="currentPage"
          @input="$emit('change-page', $event)"
          :total-rows="totalRows"
          :per-page="perPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/pagination.vue";

export default {
  name: "CustomTable",
  components: {
    Pagination,
  },
  model: {
    prop: "currentPage",
    event: "change-page",
  },
  props: {
    numberOfElement: {
      type: [Number, String],
      default: 0,
    },
    totalRows: {
      type: [Number, String],
      default: null,
    },
    perPage: {
      type: [Number, String],
      default: 10,
    },
    currentPage: {
      type: [Number, String],
      default: 1,
    },
  },
  computed: {
    showFooter() {
      return this.totalRows !== null && this.totalRows !== undefined;
    },
  },
  methods: {
    refresh() {
      if (this.$refs.bTable) {
        return this.$refs.bTable.refresh();
      }
    },
  },
};
</script>

<style scoped>
/* ======================== BẢNG HIỂN THỊ DỮ LIỆU TÙY CHỈNH ======================== */
.custom-table-wrapper {
  background-color: #ffffff;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.table-container-custom {
  overflow-x: auto;
}

.table-admin-custom {
  margin: 0;
  font-family: var(--font-body, "Inter"), sans-serif;
}

::v-deep .th-custom-style {
  background-color: rgba(241, 245, 235, 0.5) !important;
  color: var(--color-public-text-body, #374151) !important;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700 !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  padding: 14px 16px !important;
  border-bottom: 1px solid var(--outline-variant, #bfcaba) !important;
}

::v-deep .table-admin-custom tbody td {
  padding: 14px 16px !important;
  vertical-align: middle !important;
  border-color: rgba(187, 202, 186, 0.2) !important;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  height: 4px;
}
::-webkit-scrollbar-thumb {
  background: rgba(112, 122, 108, 0.2);
  border-radius: 4px;
}

/* Thanh chân bảng tin */
.table-footer-bar {
  padding: 24px;
  border-top: 1px solid rgba(187, 202, 186, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: rgba(241, 245, 235, 0.1);
}

@media (min-width: 576px) {
  .table-footer-bar {
    flex-direction: row;
  }
}

.footer-stats-text {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  color: var(--color-public-text-body, #374151);
}

.stats-highlight {
  font-weight: 700;
  color: var(--color-public-primary, #2e7d32);
}
</style>
